module.exports = __webpack_public_path__ + "assets/img/domantas.ea5b85a6.webp";